import { render } from "./employee-model.vue?vue&type=template&id=c93244c6&scoped=true"
import script from "./employee-model.vue?vue&type=script&lang=js"
export * from "./employee-model.vue?vue&type=script&lang=js"

import "./employee-model.vue?vue&type=style&index=0&id=c93244c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93244c6"]])

export default __exports__